import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { useForm } from "react-hook-form";

function MyForm(props) {
  const { handleChange } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  return (
    <Form onSubmit={handleSubmit(props.continue)}>
      <Row className="layout_mb__30">
        <Col md={6} className="layout_mb__30">
          <FloatingLabel label="Vorname">
            <Form.Control
              id="Vorname"
              type="text"
              placeholder="Vorname"
              {...register("Vorname", { required: true, maxLength: 15 })}
              onChange={handleChange("Vorname")}
            />
          </FloatingLabel>
          {errors.Vorname && <p>Bitte das Feld ausfüllen</p>}
        </Col>
        <Col md={6} className="layout_mb__30">
          <FloatingLabel label="Nachname">
            <Form.Control
              id="Nachname"
              type="text"
              placeholder="Nachname"
              {...register("Nachname", { required: true })}
              onChange={handleChange("Nachname")}
            />
          </FloatingLabel>
          {errors.Nachname && <p>Bitte das Feld ausfüllen</p>}
        </Col>
        <Col xs={12} className="layout_mb__30">
          <FloatingLabel label="Straße und Hausnummer">
            <Form.Control
              id="Straße_und_Hausnummer"
              type="text"
              placeholder="Straße und Hausnummer"
              {...register("Straße_und_Hausnummer")}
              onChange={handleChange("Straße_und_Hausnummer")}
            />
          </FloatingLabel>
        </Col>
        <Col md={6} className="layout_mb__30">
          <FloatingLabel label="PLZ">
            <Form.Control
              id="PLZ"
              type="text"
              placeholder="PLZ"
              {...register("PLZ")}
              onChange={handleChange("PLZ")}
            />
          </FloatingLabel>
        </Col>
        <Col md={6} className="layout_mb__30">
          <FloatingLabel label="Ort">
            <Form.Control
              id="Ort"
              type="text"
              placeholder="Ort"
              {...register("Ort")}
              onChange={handleChange("Ort")}
            />
          </FloatingLabel>
        </Col>
        <Col xs={12} className="layout_mb__30">
          <FloatingLabel label="E-Mail Adresse">
            <Form.Control
              id="Email"
              type="email"
              placeholder="E-Mail Adresse"
              {...register("Email", {
                required: true,
                pattern: `/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/`,
              })}
              onChange={handleChange("Email")}
            />
          </FloatingLabel>
          {errors.Email && <p>Bitte das Feld ausfüllen</p>}
        </Col>
        <Col xs={12} className="layout_mb__30">
          <FloatingLabel label="Telefonnummer">
            <Form.Control
              id="Telefonnummer"
              type="phone"
              placeholder="Telefonnummer"
              {...register("Telefonnummer", {
                required: true,
                pattern: `/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/`,
              })}
              onChange={handleChange("Telefonnummer")}
            />
          </FloatingLabel>
          {errors.Telefonnummer && <p>Bitte das Feld ausfüllen</p>}
        </Col>
        <Col xs={12} className="layout_mb__30">
          <FloatingLabel label="Geburtsdatum">
            <Form.Control
              id="Geburtsdatum"
              type="date"
              placeholder="Geburtsdatum"
              {...register("Geburtsdatum", { required: true })}
              onChange={handleChange("Geburtsdatum")}
            />
          </FloatingLabel>
          {errors.Geburtsdatum && <p>Bitte das Feld ausfüllen</p>}
        </Col>
        {/* <Col md={6} className="layout_mb__30">
          <FloatingLabel label="Geburtsort">
            <Form.Control
              id="Geburtsort"
              type="text"
              placeholder="Geburtsort"
              {...register("Geburtsort")}
              onChange={handleChange("Geburtsort")}
            />
          </FloatingLabel>
        </Col>
        <Col md={6} className="layout_mb__30">
          <FloatingLabel label="Geburtsland">
            <Form.Control
              id="Geburtsland"
              type="text"
              placeholder="Geburtsland"
              {...register("Geburtsland")}
              onChange={handleChange("Geburtsland")}
            />
          </FloatingLabel>
        </Col>
        <Col xs={12} className="layout_mb__30">
          <FloatingLabel label="Staatsangehörigkeit">
            <Form.Control
              id="Staatsangehörigkeit"
              type="text"
              placeholder="Staatsangehörigkeit"
              {...register("Staatsangehörigkeit")}
              onChange={handleChange("Staatsangehörigkeit")}
            />
          </FloatingLabel>
        </Col> */}
      </Row>
      <div className="d-flex">
        <Button color="secondary" variant="contained" onClick={props.back}>
          Zurück
        </Button>

        <Button
          type="submit"
          color="primary"
          variant="contained"
          className="btn__fill btn__fill_primary btn__fill_primary_static ms-auto"
        >
          NÄCHSTE -&gt;
        </Button>
      </div>
    </Form>
  );
}

export class FormPersonalDetails extends Component {
  curentPage = window.location.pathname
    .split("/")
    .find((item) => item === "erste-hilfe")
    ? "erste-hilfe"
    : "fuehrerschein";

  continue = (e) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/api/email/`,
      data: {
        to: "kontakt@fahrschule-bergedorf.de",
        from: "kontakt@fahrschule-bergedorf.de",
        subject: `${
          this.curentPage === "erste-hilfe"
            ? "BE: Erste Hilfe Kurs - Neue Anmeldung Fahrschule Bergedorf"
            : "BE: Anfrage von der Webseite Fahrschule Bergedorf"
        }`,
        text: `
                    <p>Vorname: ${this.props.values.Vorname}</p>
                    <p>Nachname: ${this.props.values.Nachname}</p>
                    <p>Straße und Hausnummer: ${this.props.values.Straße_und_Hausnummer}<br/>
                    <p>PLZ: ${this.props.values.PLZ}</p>
                    <p>Ort: ${this.props.values.Ort}</p>
                    <p>Email: ${this.props.values.Email}</p>
                    <p>Telefonnummer: ${this.props.values.Telefonnummer}</p>
                    <p>Geburtsdatum: ${this.props.values.Geburtsdatum}</p>
                    `,
      },
    });
    // <p>Geburtsort: ${this.props.values.Geburtsort}</p>
    // <p>Geburtsland: ${this.props.values.Geburtsland}</p>
    // <p>Staatsangehörigkeit: ${this.props.values.Staatsangehörigkeit}</p>
    this.props.nextStep();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    return (
      <>
        <h3 className="h1 layout_mb" id="contained-modal-title-vcenter">
          VORANMELDUNG
        </h3>
        <MyForm
          handleChange={this.props.handleChange}
          back={this.back}
          continue={this.continue}
        ></MyForm>
      </>
    );
  }
}

export default FormPersonalDetails;
